import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { isApiConfigured } from "@/config/api/env";
import { fetchChatArtifacts } from "@/services/chat/chatArtifactsApi";
import { threadArtifactFromRow } from "./threadArtifactMapper";
import { onThreadDocumentsChanged } from "./threadDocumentsEvents";

export const threadDocumentsQueryKey = (threadId) => [
  "do-chat",
  "thread-documents",
  threadId,
];

/**
 * The durable uploads and generated artifacts belonging to one conversation.
 */
export function useThreadDocuments(threadId) {
  const query = useQuery({
    queryKey: threadDocumentsQueryKey(threadId),
    queryFn: ({ signal }) => fetchChatArtifacts(threadId, { signal }),
    enabled: Boolean(threadId) && isApiConfigured(),
    retry: false,
  });
  const refetch = query.refetch;

  useEffect(
    () =>
      onThreadDocumentsChanged((changedThreadId) => {
        if (String(changedThreadId) !== String(threadId)) return;
        void refetch();
      }),
    [refetch, threadId],
  );

  return {
    items: (query.data ?? []).map(threadArtifactFromRow),
    isLoading: Boolean(threadId) && query.isLoading,
    isError: query.isError,
  };
}
